import React, {Component} from "react";
import {Accordion, Card, Modal, useAccordionButton} from "react-bootstrap";
import {toast} from "react-toastify";
import ApiConnect from "../../../Utils/ApiConnect";
import AutoComplete from "../../Components/AutoComplete";
import DeletePop from "../../Components/DeletePop";
import ProductAutoComplete from "../SalesPurchase/Components/ProductAutoComplete";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}

export default class PartyRate extends Component {
  constructor() {
    super();
    this.state = {
      addProductModal: false,
      editProductModal: false,
      addPartyModal: false,
      editPartyModal: false,
      selectProduct: false,
      selectedParty: false,
      deleteModal: false,
      partyData: false,
      formError: false,
      ProductList: false,
      AccountList: false,
      PartyList: false,
      btnDisable: false,
      myFData: [],
    };
  }
  componentDidMount = () => {
    this.fetchPartyData();
    this.fetchProductList();
  };
  fetchProductList = () => {
    ApiConnect.get(`/Module/SalesPurchase/Sales/SalesData`)
      .then((response) => {
        this.setState({
          ProductList: response.data.products.product,
          AccountList: response.data.account,
        });
      })
      .catch((error) => console.log(error));
  };
  fetchPartyData = () => {
    ApiConnect.get("/Module/Accounts/Party/PartyRate").then((response) =>
      this.setState({ partyData: response.data })
    );
  };
  handleChange = (e) => {
    const newFdata = { ...this.state.myFData };
    if (e.target) {
      newFdata[e.target.name] = e.target.value;
    } else {
      newFdata["product"] = e.id;
    }
    this.setState({ myFData: newFdata });
  };
  hanldelChangeAccount = (e) => { 
    this.setState({ selectedParty: e.id });
  };
  handleAddproduct = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdatas = new FormData();
    Fdatas.append("party", this.state.selectedParty);
    Fdatas.append("product", this.state.myFData.product);
    Fdatas.append("rate", this.state.myFData.rate);
    ApiConnect({
      method: "post",
      url: "/Module/Accounts/Party/NewPartyProduct",
      data: Fdatas,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            addProductModal: false,
            editProductModal: false,
            addPartyModal: false,
            editPartyModal: false,
            selectProduct: false,
            selectedParty: false,
            deleteModal: false,
            partyData: false,
            formError: false,
            btnDisable: false,
            myFData: [],
          });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.fetchPartyData();
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  };

  SettriggerModal = () => {
    this.setState({ deleteModal: false });
  };
  render() {
    console.log(this.state.myFData);
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Party Details</strong>
                  <small className="subtitle">
                    Here you can edit,delete,view Partys Details.
                  </small>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => this.setState({ addPartyModal: true })}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
          </header>
        </div>
        <div className="card">
          <div className="card-title">
            <h4>Party Details</h4>
          </div>
          <div className="card-body">
            <Accordion defaultActiveKey="0">
              {this.state.partyData &&
                this.state.partyData.map((partys, index) => (
                  <Card key={index}>
                    <Card.Header>
                      <CustomToggle eventKey={partys.id}>
                        <div className="d-flex flex-row">
                          <h4 className="col card-title">{partys.name}</h4>
                          <h4 className="col card-title d-flex flex-row">
                            <span className="material-icons text-success">
                              inventory
                            </span>
                            {partys.product.length} Products
                          </h4>
                        </div>
                      </CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey={partys.id}>
                      <Card.Body>
                        <button
                          className="right btn btn-primary btn-sm btn-round"
                          onClick={() =>
                            this.setState({
                              addProductModal: true,
                              selectedParty: partys.id,
                            })
                          }
                        >
                          <span className="material-icons-outlined">add</span>
                        </button>
                        <table className="table table-responsive">
                          <thead>
                            <tr>
                              <th>Product Name</th>
                              <th>Rate</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partys.product.map((prd, prdIndex) => (
                              <tr key={prdIndex}>
                                <td col="2">{prd.name}</td>
                                <td>{prd.rate}</td>
                                <td col="1">
                                  <button
                                    disabled={false}
                                    className="table-action btn btn-square btn-pure hover-danger"
                                    onClick={() => {
                                      this.setState({
                                        selectProduct: prd.id,
                                        selectedParty: partys.id,
                                        deleteModal: true,
                                      });
                                    }}
                                  >
                                    <span className="material-icons-outlined">
                                      delete
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                ))}
            </Accordion>
            <DeletePop
              trigger={this.state.deleteModal}
              delUrl={`/Module/Accounts/Party/DeletePartyProduct?id=${this.state.selectProduct}&party=${this.state.selectedParty}`}
              hideTrigger={this.SettriggerModal}
              fallAction={this.fetchPartyData}
            />
            <Modal
              show={this.state.addProductModal}
              className="modal-center"
              onHide={() => this.setState({ addProductModal: false })}
            >
              <Modal.Dialog>
                <Modal.Header>
                  <h5 className="modal-title">
                    New Product To Party{" "}
                    {this.state.selectedParty.name &&
                      this.state.selectedParty.name}
                  </h5>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.setState({ addProductModal: false })}
                  >
                    <span>×</span>
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <label className="form-label">Product Name</label>
                    {this.state.ProductList && (
                      <ProductAutoComplete
                        action={this.handleChange}
                        name="product"
                        placeHolder="Scan / search products by code / name"
                        items={this.state.ProductList}
                      />
                    )}
                  </div>
                  <div className="row form-group">
                    <label className="form-label">Rate</label>
                    <input
                      type="text"
                      name="rate"
                      className="form-control"
                      required
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    disabled={this.state.btnDisable}
                    className="btn btn-success"
                    onClick={(e) => this.handleAddproduct(e)}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </Modal.Dialog>
            </Modal>
            <Modal
              show={this.state.addPartyModal}
              className="modal-center"
              onHide={() => this.setState({ addPartyModal: false })}
            >
              <Modal.Dialog>
                <Modal.Header>
                  <h5 className="modal-title">New Party</h5>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.setState({ addPartyModal: false })}
                  >
                    <span>×</span>
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  {this.state.AccountList ? (
                    <div className="form-group">
                      <label>Account Head *</label>
                      <AutoComplete
                        action={this.hanldelChangeAccount}
                        name="party"
                        placeHolder="Account Head"
                        styleName="form-control input-sm d-block"
                        items={this.state.AccountList}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Product Name</label>
                      {this.state.ProductList && (
                        <ProductAutoComplete
                          action={this.handleChange}
                          name="product"
                          // default={this.state.reset}
                          // defaultFallback={this.handleProductSelect}
                          placeHolder="Scan / search products by code / name"
                          items={this.state.ProductList}
                        />
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">Product Name</label>
                      <input
                        type="number"
                        name="rate"
                        onChange={(e) => this.handleChange(e)}
                        className="form-control"
                        value={this.state.myFData.rate}
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    onClick={(e) => this.handleAddproduct(e)}
                    disabled={this.state.btnDisable}
                    className="btn btn-success"
                  >
                    Create
                  </button>
                </Modal.Footer>
              </Modal.Dialog>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
